
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class TeacherOutstandingDialog extends Serenity.EntityDialog<TeacherOutstandingRow, any> {
        protected getFormKey() { return TeacherOutstandingForm.formKey; }
        protected getIdProperty() { return TeacherOutstandingRow.idProperty; }
        protected getLocalTextPrefix() { return TeacherOutstandingRow.localTextPrefix; }
        protected getService() { return TeacherOutstandingService.baseUrl; }
        protected getDeletePermission() { return TeacherOutstandingRow.deletePermission; }
        protected getInsertPermission() { return TeacherOutstandingRow.insertPermission; }
        protected getUpdatePermission() { return TeacherOutstandingRow.updatePermission; }

        protected form = new TeacherOutstandingForm(this.idPrefix);

    }
}